// extracted by mini-css-extract-plugin
export default {"imgArea":"middleArea_imgArea__YeTwO","bottomLeftText":"middleArea_bottomLeftText__0CH5g"};